export enum RoleName {
  ADMIN = 'ADMIN',
  OWNER = 'OWNER',
  TEAMMATE = 'TEAMMATE',
  COLLABORATOR = 'COLLABORATOR',
}
